module.exports = __webpack_public_path__ + "static/media/order_icon.38fb0d3f.svg";